import { render, staticRenderFns } from "./_collection.vue?vue&type=template&id=8ac79f22&scoped=true&"
import script from "./_collection.vue?vue&type=script&lang=js&"
export * from "./_collection.vue?vue&type=script&lang=js&"
import style0 from "./_collection.vue?vue&type=style&index=0&id=8ac79f22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac79f22",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShareButtons: require('/var/www/fs-store/components/ShareButtons.vue').default,ProductsCard: require('/var/www/fs-store/components/ProductsCard.vue').default})
